import { render, staticRenderFns } from "./MessageEditDialog.vue?vue&type=template&id=7c2a3834"
import script from "./MessageEditDialog.vue?vue&type=script&lang=js"
export * from "./MessageEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports